import { c as _c } from "react/compiler-runtime";
import { CreateWaveOutcomeType } from "@/types/waves.types";
import CreateWaveOutcomeTypesItem from "./CreateWaveOutcomeTypesItem";
export default function CreateWaveOutcomeTypes(t0) {
  const $ = _c(5);
  const {
    outcomeType,
    setOutcomeType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [CreateWaveOutcomeType.MANUAL]: "Manual",
      [CreateWaveOutcomeType.REP]: "Rep",
      [CreateWaveOutcomeType.NIC]: "NIC"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const LABELS = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.values(CreateWaveOutcomeType);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== outcomeType || $[3] !== setOutcomeType) {
    t3 = <div className="tw-grid tw-grid-cols-3 tw-gap-x-4 tw-gap-y-4">{t2.map(type => <CreateWaveOutcomeTypesItem key={type} outcomeType={type} label={LABELS[type]} selectedOutcomeType={outcomeType} setOutcomeType={setOutcomeType} />)}</div>;
    $[2] = outcomeType;
    $[3] = setOutcomeType;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}